import React, { useEffect, useState } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { X, Download } from 'lucide-react'
import ModalTest from '../../../BaseModal'
import { PDFDownloadLink } from '@react-pdf/renderer'
import BodyOfPDF from '../../../PDF/Body'
import axios from '../../../../config/axios'
import { ContainerOfModal, Header, HeaderTitle, CloseDiv, ButtonContainer, Button } from '../../../styles/modal-style'
import QRCode from 'qrcode'

export interface OpForPDFType {
  id: number
  codeOfOP: string
  orderItem: {
    id: number
    ploomesProductName: string
    length?: number
    diameter?: number
    thickness?: number
    width?: number
    weight?: number
  }
  stockInProduction: {
    id: number
    stockId: number | null
    resourceId: number | null
    usedUnitOfMeasurement: string
    usedQuantity: number
    stock?: {
      description: string
    } | null
    resource?: {
      name: string
      description?: string
    } | null
  }[]
  service_stage: {
    id: number
    observation: string
    description: string
    stage: {id:number, name:string}
  }[]
}

interface GeneratePDFModalProps {
  onClickClose: () => void
}

const GeneratePDFModal:React.FC<GeneratePDFModalProps> = ({onClickClose}) => {
  const [searchParam] = useSearchParams()
  const id = searchParam.get('id')
  const [data, setData] = useState<OpForPDFType | null>(null)
  const [qrCodeDataUrl, setQrCodeDataUrl] = useState<string>('')

  const getItemName = (item: any): string => {
    return item.stock?.description || item.resource?.name || item.resource?.description || 'Item não identificado'
  }

  const processedData = data ? {
    ...data,
    stockInProduction: data.stockInProduction.map(item => ({
      ...item,
      itemName: getItemName(item)
    }))
  } : null

  useEffect(() => {
    const fetchData = async () => {
      if(id) {
        try{
         const response = await axios.get(`${process.env.REACT_APP_GATEWAY_BASE_URL}/production-flow/pcp/pdf/${id}`)
         if(response.data) {
          setData(response.data)
          
          if (response.data.id) {
            try {
              const qrCodeUrl = await QRCode.toDataURL(response.data.id.toString(), {
                width: 200,
                margin: 1,
                color: {
                  dark: '#000000',
                  light: '#FFFFFF'
                }
              })
              setQrCodeDataUrl(qrCodeUrl)
            } catch (error) {
              console.error('Erro ao gerar QR code:', error)
            }
          }
         }
        } catch(error) {
          console.error(error)
        }
      }
    }

    fetchData()
  }, [id])
  
  return (
    <ModalTest>
      <ContainerOfModal width='500px'>
        <Header>
          <HeaderTitle>Gerar PDF</HeaderTitle>
          <CloseDiv onClick={onClickClose}>
            <X size={20} />
          </CloseDiv>
        </Header>
        
        <div>
          <p style={{ marginBottom: '2rem', fontSize: '16px', color: '#666' }}>
            Clique no botão abaixo para baixar o PDF da OP
          </p>
          
          <PDFDownloadLink
            document={<BodyOfPDF data={processedData} qrCodeDataUrl={qrCodeDataUrl} />}
            fileName={`${data?.codeOfOP || 'documento'}.pdf`}
          >
            {({ loading }) => (
              <Button disabled={loading || !data || !qrCodeDataUrl}>
                <Download size={16} />
                {loading ? 'Preparando...' : 'Baixar PDF'}
              </Button>
            )}
          </PDFDownloadLink>
        </div>
      </ContainerOfModal>
    </ModalTest>
  )
}

export default GeneratePDFModal